module.exports = "<p>\n  welcome works!  Get Stoked!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /Users/Guest/Desktop/meme/src/app/welcome/welcome.component.html
// module id = ../../../../../src/app/welcome/welcome.component.html
// module chunks = main